import { useMutation } from "@tanstack/react-query";
import { RestEndpoints } from "../../../../api/endpoints";
import { getInstanceMultipartFormData } from "../../../../utils/rest";
import { IPomReportingExcelImportDataModel } from "../../../models/reportings/pom-reporting-excel-import.model";

const importReporting = async (
  contractNo: string,
  reportingNo: number,
  file: File
): Promise<IPomReportingExcelImportDataModel> => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await getInstanceMultipartFormData().post<IPomReportingExcelImportDataModel>(
    `${RestEndpoints.PomReportings}/${contractNo}/${reportingNo}/import`,
    formData
  );
  return response.data;
};

export const useImportReportingMutation = () => {
  return useMutation({
    mutationFn: ({
      contractNo,
      reportingNo,
      file,
    }: {
      contractNo: string;
      reportingNo: number;
      file: File;
    }) => importReporting(contractNo, reportingNo, file),
  });
};
